import { render, staticRenderFns } from "./TatilGuncelle.vue?vue&type=template&id=6f8f658a&"
import script from "./TatilGuncelle.vue?vue&type=script&lang=js&"
export * from "./TatilGuncelle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports